<template>
    <v-card class="d-flex align-center justify-center addtrade-card"  outlined>
        <div>
            <v-card-title class="text-center">
                <v-list-item>
                    <v-list-item-title v-if="!firstTrade"><h2>{{ $t('titles.normal') }}</h2></v-list-item-title>
                    <v-list-item-title v-else><h2>{{ $t('titles.first') }}</h2></v-list-item-title>
                    <v-spacer/>
                    <v-list-item-action v-if="!firstTrade"><v-icon class="icon" @click="closeOverlay" icon>fa-times</v-icon></v-list-item-action>
                </v-list-item>
            </v-card-title>
            <v-card-text class="px-7 pt-7">
                <v-form v-model="valid">
                    <v-content>
                        <v-row>
                            <v-col>
                                <v-autocomplete :items="this.$store.state.user.assets" item-text="ticker" item-value="id" :label="$t('items_AddTrade.asset')" :return-object="false"
                                                outlined prepend-icon="fa-euro-sign" :rules="assetRule" v-model="tradeAsset"/>
                            </v-col>
                            <v-col>
                                <v-autocomplete :items="brokerAccounts" item-value="id" :return-object="false"
                                                :label="$t('items_AddTrade.account')" outlined prepend-icon="fa-university" :rules="brokerAccountRule" v-model="tradeBrokerAccount">
                                    <template v-slot:selection="data">{{ (data.item.identifier !== '')? data.item.identifier : data.item.broker.name }}</template>
                                    <template v-slot:item="data">{{ (data.item.identifier !== '')? `${data.item.broker.name} · ${data.item.identifier}` :  data.item.broker.name }}</template>
                                </v-autocomplete>
                            </v-col>
                            <v-col>
                                <v-select :items="this.$store.state.sides" :label="$t('items_AddTrade.side')" outlined prepend-icon="fa-arrows-alt-v" v-model="tradeSide"/>
                            </v-col>
                        </v-row>

                        <v-divider class="mt-n5 mb-3"/>

                        <v-row>
                            <v-col>
                                <v-menu :clonombrese-on-content-click="false" offset-y transition="scale-transition" v-model="menuOpenDate">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field @blur="openDate = parseDate(openDateFormatted)" :label="$t('items_AddTrade.entryDate')" outlined persistent-hint
                                                      prepend-icon="fa-calendar" readonly v-model="openDateFormatted" v-on="on"/>
                                    </template>
                                    <v-date-picker @input="menuOpenDate = false" no-title v-model="openDate"/>
                                </v-menu>
                                <v-menu :close-on-content-click="false" offset-y transition="scale-transition" v-model="menuCloseDate">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field :rules="closeDateRule" @blur="closeDate = parseDate(closeDateFormatted)" :label="$t('items_AddTrade.closeDate')"
                                                      outlined persistent-hint prepend-icon="fa-calendar" readonly v-model="closeDateFormatted" v-on="on"/>
                                    </template>
                                    <v-date-picker @input="menuCloseDate = false" no-title v-model="closeDate"/>
                                </v-menu>
                            </v-col>
                            <v-col>
                                <!--v-text-field :rules="timeRule" label="Open Time" outlined prepend-icon="fa-clock" v-model="openTime"/!-->
                                <v-menu ref="menu" v-model="menuOpenTime" :close-on-content-click="false" :nudge-right="40" :return-value.sync="openTime"
                                        transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field v-model="openTime" :label="$t('items_AddTrade.entryTime')" prepend-icon="fa-clock" readonly v-on="on" outlined></v-text-field>
                                    </template>
                                    <v-time-picker v-if="menuOpenTime" v-model="openTime" @click:minute="$refs.menu.save(openTime)"></v-time-picker>
                                </v-menu>
                                <!--v-text-field :rules="timeRule" label="Close Time" outlined prepend-icon="fa-clock" v-model="closeTime"/!-->
                                <v-menu ref="menu2" v-model="menuCloseTime" :close-on-content-click="false" :nudge-right="40" :return-value.sync="closeTime"
                                        transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field v-model="closeTime" :label="$t('items_AddTrade.closeTime')" prepend-icon="fa-clock" readonly v-on="on" outlined></v-text-field>
                                    </template>
                                    <v-time-picker v-if="menuCloseTime" v-model="closeTime" @click:minute="$refs.menu2.save(closeTime)"></v-time-picker>
                                </v-menu>
                            </v-col>
                            <v-col>
                                <v-text-field :rules="priceRule" :hint="$t('hintDigits')" :label="$t('items_AddTrade.entryPrice')" outlined
                                              prepend-icon="fa-chart-line" type="number" v-model="tradeEntryPrice"/>
                                <v-text-field :rules="priceRule" :hint="$t('hintDigits')" :label="$t('items_AddTrade.closePrice')" outlined
                                              prepend-icon="fa-chart-line" type="number" v-model="tradeClosePrice"/>
                            </v-col>
                        </v-row>

                        <v-divider class="mt-n5 mb-3"/>

                        <v-row>
                            <v-col>
                                <v-text-field :rules="priceRule" :hint="$t('hintDigits')" :label="$t('items_AddTrade.stopLoss')" outlined
                                              prepend-icon="fa-coins" type="number" v-model="tradeStopLossPrice"/>
                                <v-autocomplete :items="strategies" item-text="name" item-value="id" :return-object="false"
                                                :label="$t('items_AddTrade.strategy')" outlined prepend-icon="fa-bezier-curve" :rules="strategyRule" v-model="tradeStrategy"/>
                            </v-col>
                            <v-col>
                                <v-text-field :label="$t('items_AddTrade.grossProfit')" :hint="$t('hintProfit')" outlined prepend-icon="fa-coins" type="number" v-model="tradeGrossProfit"/>
                                <v-autocomplete :items="this.$store.state.book.moods" :label="$t('items_AddTrade.mood')" outlined prepend-icon="fa-thermometer-half" :rules="moodRule" v-model="tradeMood"/>
                            </v-col>
                            <v-col>
                                <v-text-field :rules="commissionsRule" :label="$t('items_AddTrade.commissions')" outlined prepend-icon="fa-coins" type="number" v-model="tradeCommissions"/>
                                <div class="d-flex align-center justify-center mt-3">
                                    <v-btn class="text-center" @click="addTrade" outlined>{{ $t('btnAdd_AddTrade') }}</v-btn>
                                </div>
                            </v-col>
                        </v-row>
                    </v-content>
                </v-form>
            </v-card-text>
        </div>

      <!-- Overlay for not allowed !-->
      <v-overlay :dark="false" :value="overlayNotAllowed">
        <NotAllowed/>
      </v-overlay>
    </v-card>
</template>

<script>
    import { mapMutations } from 'vuex';
    import Repository from '../../repositories/journal';
    import NotAllowed from "@/views/Journal/components/NotAllowed";

    export default {
        name: "AddTrade",
      components: {NotAllowed},
      data() {
            return {
                // Not Allowed
                overlayNotAllowed: false,

                //Trade Time Avg Related
                tradeTimeAvg: 0,

                // The first trade
                firstTrade: false,

                openDate: new Date().toISOString().substr(0, 10),
                closeDate: new Date().toISOString().substr(0, 10),
                openDateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
                closeDateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
                menuOpenDate: false,
                menuCloseDate: false,
                menuOpenTime: false,
                menuCloseTime: false,
                openTime: null,
                closeTime: null,

                tradeAsset: 0,
                tradeSide: '',
                tradeBrokerAccount: 0,
                tradeOpenTime: '',
                tradeCloseTime: '',
                tradeEntryPrice: 0,
                tradeClosePrice: 0,
                tradeStopLossPrice: 0,
                tradeGrossProfit: 0,
                tradeCommissions: 0,
                tradeStrategy: 0,
                tradeMood: '',

                // DATA
                brokerAccounts: [],
                strategies: [],

                // RULES
                valid: false,
                closeDateRule: [
                    // eslint-disable-next-line no-unused-vars
                    d => this.closeDate >= this.openDate || 'Close date must be after the open date'
                ],
                timeRule: [
                    t => !!t || 'Time is required',
                    t => t.length <= 5 || 'Add a valid HH:MM time',
                    t => /.+:.+/.test(t) || 'Add a valid HH:MM time',
                ],
                priceRule: [
                    p => p > 0 || 'Price must be greater than 0',
                ],
                commissionsRule: [
                    c => c >= 0 || 'Commissions must be equal or greater than 0',
                ],
                assetRule: [
                    a => !!a || 'Asset is required',
                ],
                brokerAccountRule: [
                    b => !!b || 'Broker account is required',
                ],
                strategyRule: [
                    s => !!s || 'Watchlist is required',
                ],
                moodRule: [
                    m => !!m || 'Mood is required',
                ],
            };
        },
        watch: {
            openDate() {
                this.openDateFormatted = this.formatDate(this.openDate);
            },
            closeDate() {
                this.closeDateFormatted = this.formatDate(this.closeDate);
            }
        },
        created() {
            this.verifyNotAllowed();
            this.firstTrade = this.$store.state.book.noTrades;
            this.defaultValues();
        },
        methods: {
            verifyNotAllowed() {
              this.overlayNotAllowed = (this.$store.state.user.assets.length === 0 || this.$store.state.user.brokerAccounts.length === 0);
            },
            defaultValues() {
                this.strategies = [{ name: 'None', id: -7, }];
                this.$store.state.user.brokerAccounts.forEach((brokerAccount) => { if(!brokerAccount.verified) this.brokerAccounts.push(brokerAccount) });
                this.$store.state.user.strategies.forEach((strategy) => { this.strategies.push(strategy); });
                this.tradeAsset = this.$store.state.user.assets[0].id;
                this.tradeSide = this.$store.state.sides[0];
                this.tradeStrategy = this.strategies[0].id;
                this.tradeMood = this.$store.state.book.moods[0];
                this.tradeBrokerAccount = this.brokerAccounts[0].id;
            },
            formatDate(date) {
                if (!date) return null;

                const [year, month, day] = date.split('-');
                return `${month}/${day}/${year}`
            },
            parseDate(date) {
                if (!date) return null;

                const [month, day, year] = date.split('/');
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },
            ...mapMutations(['setTrades', 'setNoTrades', 'setStats', 'setTradesPageInfo', 'setLoadingTrades']),
            addTrade() {
                if (this.valid) {
                    //this.tradeOpenTime = `${this.openDate} ${this.openTime}`;
                    //this.tradeCloseTime = `${this.closeDate} ${this.closeTime}`;
                    let netProfit = ( this.tradeGrossProfit * 1 ) - Math.abs(this.tradeCommissions * 1 );
                    let priceDistance = Math.abs(this.tradeEntryPrice - this.tradeClosePrice );
                    let pipValue = (priceDistance > 0.0)? ( Math.abs(this.tradeGrossProfit * 1) / (priceDistance)).toFixed(2) : (0).toFixed(2);
                    let openTimeArray = this.openTime.split(':');
                    let closeTimeArray = this.closeTime.split(':');
                    let openDateTime = new Date(this.openDate.substr(0, 4), this.openDate.substr(5, 2) - 1, this.openDate.substr(8, 2), openTimeArray[0], openTimeArray[1]);
                    let closeDateTime = new Date(this.closeDate.substr(0, 4), this.closeDate.substr(5, 2) - 1, this.closeDate.substr(8, 2), closeTimeArray[0], closeTimeArray[1]);

                    // Validates rules
                    if(openDateTime > closeDateTime) {
                        alert('Trade can\'t be added.\nClose time SHOULD be after the Open time.');
                        return;
                    }
                    if((this.tradeStopLossPrice * 1) > (this.tradeEntryPrice * 1) && this.tradeSide.startsWith("B", 0)){
                        alert('Trade can\'t be added.\nIn a Long(Buy) trade, original StopLoss price CANNOT be higher than the Entry price.');
                        return;
                    }
                    if((this.tradeStopLossPrice * 1) < (this.tradeEntryPrice * 1) && this.tradeSide.startsWith("S", 0)){
                        alert('Trade can\'t be added.\nIn a Short(Sell) trade, original StopLoss price CANNOT be lower than the Entry price.');
                        return;
                    }
                    if(this.tradeSide.startsWith("B", 0) &&
                        (((this.tradeClosePrice * 1) > (this.tradeEntryPrice * 1) && (this.tradeGrossProfit * 1 < 0)) ||
                        ((this.tradeClosePrice * 1) < (this.tradeEntryPrice * 1) && (this.tradeGrossProfit * 1 > 0))) ){
                        // eslint-disable-next-line no-useless-escape
                        alert(`Trade can\'t be added.\nIn a Long(Buy) trade with close price ${(this.tradeClosePrice * 1 > this.tradeEntryPrice * 1)? 'higher' : 'lower' } than the entry price, the Gross Profit CANNOT be ${(this.tradeGrossProfit * 1 > 0)? 'positive' : 'negative' }.`);
                        return;
                    }
                    if(this.tradeSide.startsWith("S", 0) &&
                        (((this.tradeClosePrice * 1) > (this.tradeEntryPrice * 1) && (this.tradeGrossProfit * 1 > 0)) ||
                        ((this.tradeClosePrice * 1) < (this.tradeEntryPrice * 1) && (this.tradeGrossProfit * 1 < 0))) ){
                        // eslint-disable-next-line no-useless-escape
                        alert(`Trade can\'t be added.\nIn a Short(Sell) trade with close price ${(this.tradeClosePrice * 1 > this.tradeEntryPrice * 1)? 'higher' : 'lower' } than the entry price, the Gross Profit CANNOT be ${(this.tradeGrossProfit * 1 > 0)? 'positive' : 'negative' }.`);
                        return;
                    }

                    let trade = {
                        //openTime: new Date(this.openDate.substr(0, 4), this.openDate.substr(5, 2) - 1, this.openDate.substr(8, 2), openTimeArray[0], openTimeArray[1]),
                        //closeTime: new Date(this.closeDate.substr(0, 4), this.closeDate.substr(5, 2) - 1, this.closeDate.substr(8, 2), closeTimeArray[0], closeTimeArray[1]),
                        side: this.tradeSide.toUpperCase(),
                        mood: this.tradeMood.toUpperCase(),
                        openTime: openDateTime,
                        closeTime: closeDateTime,
                        entryPrice: ( this.tradeEntryPrice * 1 ),
                        closePrice: ( this.tradeClosePrice * 1 ),
                        stopLossPrice: ( this.tradeStopLossPrice * 1 ),
                        netProfit: netProfit,
                        pipValue: ( pipValue * 1 ),
                        commisions: ( this.tradeCommissions * 1 ),
                        user: { id: this.$store.state.user.id },
                        strategy: { id: this.tradeStrategy },
                        asset: { id: this.tradeAsset },
                        brokerAccount: { id: this.tradeBrokerAccount }
                    };

                    // Validate if the trade does not have a strategy
                    if(this.tradeStrategy === -7)
                        delete trade.strategy;

                    this.setLoadingTrades(true);
                    Repository.createTrade(trade).then((response) => {
                        if(response.status < 400){
                            let filter = this.$store.state.book.currentFilter;
                            Repository.filteredTradesOfUser(filter, this.$store.state.book.pageable).then((responseTrades) => {
                                let trades = responseTrades.data.content;
                                this.tradeTimeAvg = 0;
                                trades.forEach((item) => {
                                    item.mood = item.mood[0] + item.mood.slice(1).toLowerCase();
                                    item.side = item.side[0] + item.side.slice(1).toLowerCase();
                                    item.tradeTime = this.convertDuration(item.tradeTime);
                                    item.openTime = new Date(item.openTime);
                                    item.closeTime = new Date(item.closeTime);
                                    //item.openTime = this.convertUTCDateToLocalDate(new Date(item.openTime));
                                });
                                this.setTrades(responseTrades.data.content);
                                this.setNoTrades(false);
                                let stats = {tradeTimeAvg: this.secondsToHHMMSS(this.tradeTimeAvg / trades.length)};
                                this.setStats(stats);
                                this.setTradesPageInfo({totalElements: response.data.totalElements, totalPages: response.data.totalPages});
                            });
                        }
                        this.$emit('newTrade');
                    }).catch((error) => {
                        if (error.response.status === 500)
                            this.$emit('tradesLimitReached');
                    });
                } else
                    alert('Trade can\'t be added.\nThere are one or more mandatory fields that are not filled.');
            },
            convertDuration(isoFormat){
                let iso8601DurationRegex = /(-)?P(?:([.,\d]+)Y)?(?:([.,\d]+)M)?(?:([.,\d]+)W)?(?:([.,\d]+)D)?T(?:([.,\d]+)H)?(?:([.,\d]+)M)?(?:([.,\d]+)S)?/;
                let matches = isoFormat.match(iso8601DurationRegex);

                // Sum to the trade time average
                this.tradeTimeAvg += (matches[8] === undefined ? 0 : matches[8] * 1) +
                    (matches[7] === undefined ? 0 : matches[7] * 60) +
                    (matches[6] === undefined ? 0 : matches[6] * 3600) +
                    (matches[5] === undefined ? 0 : matches[5] * 86400) +
                    (matches[4] === undefined ? 0 : matches[4] * 604800);

                return {
                    sign: matches[1] === undefined ? '+' : '-',
                    years: matches[2] === undefined ? 0 : matches[2],
                    months: matches[3] === undefined ? 0 : matches[3],
                    weeks: matches[4] === undefined ? 0 : matches[4],
                    days: matches[5] === undefined ? 0 : matches[5],
                    hours: matches[6] === undefined ? 0 : matches[6],
                    minutes: matches[7] === undefined ? 0 : matches[7],
                    seconds: matches[8] === undefined ? 0 : matches[8]
                };
            },
            convertUTCDateToLocalDate(date) {
                let newDate = new Date(date.getTime() + date.getTimezoneOffset()*60*1000);
                let offset = date.getTimezoneOffset() / 60;
                let hours = date.getHours();
                newDate.setHours(hours - offset);
                return newDate;
            },
            secondsToHHMMSS(secondsToConvert) {
                let sec_num = parseInt(secondsToConvert, 10); // don't forget the second param
                let hours = Math.floor(sec_num / 3600);
                let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
                let seconds = sec_num - (hours * 3600) - (minutes * 60);

                if (hours < 10)
                    hours = "0" + hours;
                if (minutes < 10)
                    minutes = "0" + minutes;
                if (seconds < 10)
                    seconds = "0" + seconds;

                return `${hours}h ${minutes}m ${seconds}s`;
            },
            closeOverlay() {
                this.$emit('closeOverlay');
            }
        },
    }
</script>



<style>
.addtrade-card{
    background-color: var(--v-mainWhite-base) !important;
    color: var(--v-mainBlack-base) !important;
    
}
</style>
